package gr.tech.pdfgenerator.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.rememberCoroutineScope
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.icons.fa.FaGoogle
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.layout.HorizontalDivider
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import gr.tech.pdfgenerator.components.layouts.AuthPageLayout
import gr.tech.pdfgenerator.styles.Theme
import gr.tech.pdfgenerator.util.CONSTANTS.FONT_FAMILY
import gr.tech.pdfgenerator.util.BACKEND
import kotlinx.browser.window
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.Text

@Page(routeOverride = "login")
@Composable
fun UserLoginPage() {
    AuthPageLayout(
        title = "Login",
        redirectIfLoggedIn = "/projects",
        requiredRoles = emptyList()
    ) {
        UserLoginScreen()
    }
}

@Composable
fun UserLoginScreen() {
    val scope = rememberCoroutineScope()
    val ctx = rememberPageContext()
    val breakpoint = rememberBreakpoint()

    Box(
        modifier = Modifier.fillMaxSize().backgroundColor(Theme.HalfBlack.rgb),
        contentAlignment = Alignment.Center
    ) {
        Column(
            modifier = Modifier
                .width(450.px)
                .padding(25.px)
                .borderRadius(5.px)
                .backgroundColor(Theme.LightGray.rgb),
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            H1(
                Modifier
                    .fontFamily(FONT_FAMILY)
                    .fontSize(2.cssRem)
                    .fontWeight(FontWeight.Bold)
                    .toAttrs()
            ) {
                Text("Sign In")
            }

            HorizontalDivider()

            //Sign In
            Button(
                colorPalette = null,
                modifier = Modifier
                    .classNames("box")
                    .height(54.px)
                    .color(Colors.White)
                    .fontFamily(FONT_FAMILY)
                    .fontWeight(FontWeight.Medium)
                    .fontSize(16.px)
                    .backgroundColor(Theme.DarkGreen.rgb),
                onClick = {
                    window.location.href = "${BACKEND.BACKEND_URL}${BACKEND.ROUTES.USER_OAUTH_LOGIN}"
                }
            ) {
                FaGoogle(
                    Modifier.color(Colors.White).margin(right = 10.px),
                    size = IconSize.XL
                )
                SpanText(text = "Google Provider")
            }
        }
    }
}
